import Joi from "joi";
import { emailRegex } from "../../../utils/common";
import { logger } from "../../../utils/logger";

export const employeeValidationSchema = Joi.object({
  employee_code: Joi.string().allow("",null).optional(),

  salary_type: Joi.string().valid("salary", "wages").required().messages({
    // "string.empty": "Salary Type is required.",
    // "any.required": "Salary Type is required",
    "string.pattern.base": "Salary Type is required.",
    "string.base": "Salary Type is required.",
    "string.empty": "Salary Type required.",
  }),
  first_name: Joi.string().min(1).max(255).required().messages({
    "string.empty": "Employee first name is required.",
    "string.min": "Employee first name must be at least 1 characters.",
    "string.max": "Employee first name must not exceed 255 characters.",
    "any.required": "Employee first name is required.",
  }),
  last_name: Joi.string().min(1).max(255).required().messages({
    "string.empty": "Employee last name is required.",
    "string.min": "Employee last name must be at least 1 characters.",
    "string.max": "Employee last name must not exceed 255 characters.",
    "any.required": "Employee last name is required.",
  }),
  phone: Joi.number()
    .integer()
    .required()
    .custom((value, helpers) => {
      const trimmedValue = value.toString().trim();

      if (trimmedValue === "") {
        return helpers.error("any.required");
      } else {
        if (!/^[6-9][0-9]{9}$/.test(trimmedValue)) {
          return helpers.error("any.invalid");
        }
      }
      return Number(trimmedValue);
    })
    .messages({
      "any.required": "Phone number is required.",
      "number.empty": "Phone number is required.",

      "number.base": "Phone number is required.",
      "any.invalid": "Invalid phone number format.",
    }),
  alternative_phone: Joi.number()
    .integer()
    .allow("",null)
    .custom((value, helpers) => {
      const trimmedValue = value.toString().trim();

      if (trimmedValue === "") {
        return helpers.error("any.required");
      } else {
        if (!/^[6-9][0-9]{9}$/.test(trimmedValue)) {
          return helpers.error("any.invalid");
        }
      }
      return Number(trimmedValue);
    }).messages({
      "any.invalid": "Invalid phone number format.",
    }),
  shift_type: Joi.string().allow("",null).optional().messages({
    "string.empty": "shifts is required.",
    "any.required": "shifts is required.",
  }),
  email: Joi.string().pattern(emailRegex).email({ tlds: { allow: false } })
  // .required()
  .allow("",null)
  .messages({
    "string.pattern.base": "Invalid  email format",
    "string.base": "Email is required.",
    "string.required": "Email is required.",
    "string.invalid": "Email is required.",
    "string.empty": "Email is required.",
    "string.email": "Please provide a valid email address.",
  }),
  personal_email: Joi.string()
    .pattern(emailRegex)
    .email({ tlds: { allow: false } })
    .allow("", null)
    .messages({
      "string.pattern.base": "Invalid  email format",
      "string.base": "Email is required.",
      "string.required": "Email is required.",
      "string.invalid": "Email is required.",
      "string.empty": "Email is required.",
      "string.email": "Please provide a valid email address.",
    }),
  // employment_status: Joi.string().required().messages({
  //   "string.pattern.base": "Employment status is required.",

  //   "string.base": "Employment status is required.",
  //   "string.empty": "Employment status is required.",
  // }),
  employment_type: Joi.string().required().messages({
    "string.pattern.base": "Employment Type is required.",

    "string.base": "Employment Type is required.",
    "string.empty": "Employment Type required.",
  }),

  provision_period_days: Joi.number().integer().max(365).required().messages({
    "any.required": "Provision period days is required.",
    "number.base": "Provision period days is required.",

    "number.empty": "Provision period days is required.",
    "number.max": "Provision period days must not exceed 365.",
  }),

  contract_start: Joi.date()
    .required()
    .messages({
      "date.base": "Contract start date is required.",
      "any.invalid": "Contract start date must be after the join date.",
      "any.required": "Contract start date is required.",
    }).custom((value, helpers) => {
      const { contract_start, join_date } = helpers?.prefs?.context || {};

      const joinDate = new Date(join_date);
      logger.log({ contract_start, joinDate }, "contracjjkjsdjkshakjsad")



      if (new Date(contract_start) < joinDate) {
        return helpers.error("any.invalid", {
          message: "Contract start date must be after the join date.",
        });
      }



      return value; // Validation passed
    }),

  contract_end: Joi.date()
    .required()
    // .greater(Joi.ref('contract_start'))
    .messages({
      "any.required": "Contract end date is required.",
      "date.base": "Contract end date is required.",
      // "any.invalid": "Contract end date must be a valid date.",

      "any.invalid": "Contract end date must be after the contract start date.",
    }).custom((value, helpers) => {
      const { contract_start, contract_end } = helpers?.prefs?.context || {};

      logger.log(contract_start, contract_end, "sadksacontract_end")

      if (new Date(contract_start) > new Date(contract_end)) {
        return helpers.error("any.invalid", {
          message: "Contract end date must be after the join date.",
        });

      }

      return value; // Validation passed
    }),

  // contract_amount: Joi.string().pattern(/^\d+$/).allow("").messages({
  //   "string.pattern.base": "Contract amount must be a valid number.",
  // }),
  branch_id: Joi.number().integer().required().messages({
    "number.pattern.base": "Branch is required.",

    "number.base": "Branch is required.",
    "number.empty": "Branch is required.",
  }),
  department_id: Joi.number().integer()
  // .required()
  .allow("",null)
  .messages({
    "number.pattern.base": "Department is required.",

    "number.base": "Department is required.",
    "number.empty": "Department is required.",
  }),
  designation_id: Joi.number().integer()
  // .required()
  .allow("",null)
  .messages({
    "number.base": "Designation is required.",
    "number.empty": "Designation is required.",
    "number.pattern.base": "Designation is required.",
  }),
  // qualification: Joi.string()
  // .valid(
  //   "0001", "0002", "0003", "0004", "0005", 
  //   "0006", "0007", "0008", "0009", "0010", 
  //   "0011", "0012", "0013", "0014", "0015", 
  //   "0016", "0017", "0018", "0019", "0020"
  // )
  // .allow("", null)
  // // .required()
  // .messages({
  //   "string.empty": "Qualification Status is required.",
  //   "any.required": "Qualification Status is required.",
  // }),
  qualification: Joi.string().min(1).max(255).allow("", null).messages({
    "string.empty": "Employee first name is required.",
    "string.min": "Employee first name must be at least 1 characters.",
    "string.max": "Employee first name must not exceed 255 characters.",
  }),

  date_of_birth: Joi.date().required().messages({
    "date.base": "Date of birth is required.",
    "any.required": "Date of birth is required.",
  }),

  join_date: Joi.date().required().messages({
    "date.base": "Join Date is required.",
    "any.required": "Join Date is required.",
  }).custom((value, helpers) => {
    const { date_of_birth, } = helpers?.prefs?.context || {};

    // Ensure both fields are present before applying custom validation
    if (date_of_birth && value) {
      const dob = new Date(date_of_birth);
      const join = new Date(value);

      // Calculate the gap in years between date_of_birth and join_date
      const yearDiff = join.getFullYear() - dob.getFullYear();
      const monthDiff = join.getMonth() - dob.getMonth();
      const dayDiff = join.getDate() - dob.getDate();

      // Ensure the gap is at least 18 years
      if (
        yearDiff < 18 ||
        (yearDiff === 18 && (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)))
      ) {
        return helpers.error("any.invalid", {
          message: "There must be at least an 18-year gap between date of birth and join date.",
        });
      }
    }

    return value; // Validation passed
  })
    .messages({
      "any.invalid": "There must be at least an 18-year gap between date of birth and join date.",
    }),
  gender: Joi.string().valid("male", "female", "other").required().messages({
    "string.empty": "Gender is required.",
    "any.required": "Gender is required.",
  }),
  blood_group: Joi.string()
    .valid("A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-", "other", "")
    .allow("",null)
    .messages({
      "string.empty": "blood group is required.",
      "any.required": "blood group is required.",
    }),
  marital_status: Joi.string()
    .valid("single", "married", "divorced", "widowed")
    .allow("", null)
    // .required()
    .messages({
      "string.empty": "Marital Status is required.",
      "any.required": "Marital Status is required.",
    }),
  status: Joi.string().allow("").optional(),
  is_new_hire: Joi.boolean().allow("").optional(),
  // guardian_name: Joi.string().allow("",null).optional(),
  // guardian_relationship: Joi.string().allow("",null).optional(),
  guardian_name: Joi.string().required().messages({
    "string.empty": "Guardian Name is required.",
    "any.required": "Guardian Name is required.",
  }),
  guardian_relationship: Joi.string().required().messages({
    "string.empty": "Guardian Relationship is required.",
    "any.required": "Guardian Relationship is required.", 
  }),

  
  is_same_permanent: Joi.boolean().required(),

  permanent_address: Joi.string().min(3).max(500)
  // .required()
  .allow("",null)
  .messages({
    "string.empty": "Address is required.",
    "any.required": "Address is required.",
    "any.invalid": "Address is required.",

    "string.min": "Address must be at least 3 characters.",
    "string.max": "Address must not exceed 500 characters.",
  }),
  permanent_city: Joi.string().min(2).max(300)
  // .required()
  .allow("",null)
  .messages({
    "string.empty": "City is required.",
    "any.required": "City is required.",
    "any.invalid": "City is required.",

    "string.min": "City must be at least 2 characters.",
    "string.max": "City must not exceed 300 characters.",
  }),
  permanent_state: Joi.number().integer()
  // .required()
  .allow("",null)
  .messages({
    "number.base": "State is required.",
    "any.required": "State is required.",
  }),
  permanent_country: Joi.string().min(3).max(100).required().messages({
    "string.min": "Country must be at least 3 characters.",
    "string.max": "Country must not exceed 100 characters.",
    "any.required": "Country is required.",
  }),
  permanent_pincode: Joi.string()
    .pattern(/^\d{6}$/)
    // .required()
    .allow("",null)
    .messages({
      "string.empty": "Pincode is required.",
      "any.required": "Pincode is required.",
      "any.invalid": "Pincode is required.",

      "string.pattern.base": "Pincode must be exactly 6 digits.",
    }),
  permanent_landmark: Joi.string().allow("").optional(),
  present_address: Joi.string().min(3).max(500)
  // .required()
  .allow("",null)
  .messages({
    "string.empty": "Address is required.",
    "any.required": "Address is required.",
    "any.invalid": "Address is required.",

    "string.min": "Address must be at least 3 characters.",
    "string.max": "Address must not exceed 500 characters.",
  }),
  present_city: Joi.string().min(2).max(300)
  // .required()
  .allow("",null)
  .messages({
    "string.empty": "City is required.",
    "any.required": "City is required.",
    "any.invalid": "City is required.",

    "string.min": "City must be at least 2 characters.",
    "string.max": "City must not exceed 300 characters.",
  }),
  present_state: Joi.number().integer()
  // .required()
  .allow("",null)
  .messages({
    "number.base": "State is required.",
    "any.required": "State is required.",
  }),
  present_country: Joi.string().min(3).max(100)
  // .required()
  .allow("",null)
  .messages({
    "string.min": "Country must be at least 3 characters.",
    "string.max": "Country must not exceed 100 characters.",
    "any.required": "Country is required.",
  }),
  present_pincode: Joi.string()
    .pattern(/^\d{6}$/)
    // .required()
    .allow("",null)
    .messages({
      "string.empty": "Pincode is required.",
      "any.required": "Pincode is required.",
      "any.invalid": "Pincode is required.",

      "string.pattern.base": "Pincode must be exactly 6 digits.",
    }),

  present_landmark: Joi.string().allow("").optional(),
})
  .when(Joi.object({ is_same_permanent: true }).unknown(), {
    then: Joi.object({
      present_address: Joi.string().allow("", null),
      present_city: Joi.string().allow("", null),
      present_state: Joi.number().allow("", null),
      present_country: Joi.string().allow("", null),
      present_pincode: Joi.string().allow("", null),
    }),
  })
  .when(Joi.object({ employment_type: "full_time" }).unknown(), {
    then: Joi.object({
      contract_end: Joi.date().allow("", null),
      contract_start: Joi.date().allow("", null),
    }),
  })
  .when(Joi.object({ employment_type: "part_time" }).unknown(), {
    then: Joi.object({
      // employment_status: Joi.string().allow("", null),
      contract_end: Joi.date().allow("", null),
      contract_start: Joi.date().allow("", null),
      provision_period_days: Joi.number().allow("", null),
    }),
  })
  .when(Joi.object({ employment_type: "contractual" }).unknown(), {
    then: Joi.object({
      // employment_status: Joi.string().allow("", null),

    }),
  })
  // .when(Joi.object({ employment_status: "provisionperiod" }).unknown(), {
  //   then: Joi.object({
  //     // provision_period_days:Joi.string().allow("",null)
  //   }),
  // })
  .when(Joi.object({ employment_status: "permanent" }).unknown(), {
    then: Joi.object({
      provision_period_days: Joi.number().allow("", null),
    }),
  })
  .when(Joi.object({ guardian_relationship: Joi.valid('', null) }).unknown(), {
    then: Joi.object({
      guardian_name: Joi.string().allow("", null),
    }),
  })
  .when(Joi.object({ guardian_name: Joi.valid('', null)}).unknown(), {
    then: Joi.object({
      guardian_relationship: Joi.string().allow("", null),
    }),
  }).unknown({ allow: true })